const toggleModal = (target) => {
  $(target).toggleClass('active');
};

$(document).on('click', '[data-modal]', function () {
  $('.modal.active').removeClass('active');
  const target = $(this).data('modal');
  const unique = $(this).attr('data-modal-unique');

  if (unique) { // if modal has unique id
    toggleModal('#modal--' + target + unique);
  } else {
    toggleModal('#modal--' + target);
  }

  // disable scroll
  $('html, body').css('overflow', 'hidden');

  if (!target.length) {
    return;
  }
});

$('.modal__close').on('click', function () {
  let modal = $(this).parent().parent();
  $('html, body').css('overflow', '');
  toggleModal(modal);
});

$(document).keydown(function (e) {
  if (e.keyCode == 27) {
    if ($('.modal.active').length != 0) {
      $('html, body').css('overflow', '');
      toggleModal('.active');
    }
  }
});
